// Prepended to every fragment effect. Each effect file defines:
//   vec3 effect(vec2 uv)
uniform sampler2D uTexture;
uniform vec2 uResolution;   // webcam size in pixels
uniform float uTime;
uniform float uAmount;
uniform float uPixelSize;
uniform float uLevels;
uniform bool uMirror;

varying vec2 vUv;
varying float vElevation;

float luma(vec3 c)
{
    return dot(c, vec3(0.299, 0.587, 0.114));
}

float random(vec2 st)
{
    return fract(sin(dot(st, vec2(12.9898, 78.233))) * 43758.5453123);
}

vec3 sampleCam(vec2 uv)
{
    if(uMirror) uv.x = 1.0 - uv.x;
    return texture2D(uTexture, uv).rgb;
}

// Cheap thermal-style colour ramp
vec3 heat(float v)
{
    return clamp(vec3(
        1.5 - abs(4.0 * v - 3.0),
        1.5 - abs(4.0 * v - 2.0),
        1.5 - abs(4.0 * v - 1.0)
    ), 0.0, 1.0);
}
